import React from "react";
import "./ErrorElement.css";
import { useRouteError } from "react-router-dom";

function ErrorElement() {
    const error = useRouteError();
    return (
        <div role="alert" className="error-fallback">
            <h2>Oops! Something went wrong 🚨</h2>
            {error && <pre className="error-message">{error.message}</pre>}
            {/* <a href="/" className="error-link">⬅ Go Home</a> */}
        </div>
    );
}

export default ErrorElement;
